import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { TelemetryModule } from "types";
import { Page } from "../Page";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";
import { Loader } from "@/components/Loader";
import { EditTelemetryModuleForm } from "@/components/ServerSideTracking/EditTelemetryModuleForm";
import { useSeller } from "@/hooks/useAccount";
import { useResource } from "@/hooks/useResource";

export const TelemetryModulePage = () => {
    const { id } = useParams<{ id?: ID }>();
    const { data: module, isLoading } = useResource<TelemetryModule>(["telemetryModules", id]);
    const seller = useSeller();
    const configuration = seller?.preferences?.telemetry?.modules?.find((config) => config.module.id === module?.id);
    const history = useHistory();

    const handleTelemetryLinkClick = () => {
        history.push("/marketing/serverSideTracking");
    };

    const defaultModule: TelemetryModule = {
        name: "",
        description: "",
        seller: seller,
        parameters: [],
    };

    return (
        <Page title={module?.name ?? "New Integration"}>
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Marketing</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleTelemetryLinkClick}>Server Side Tracking</Breadcrumb.Item>
                        <Breadcrumb.Item>{module?.name ?? "New Integration"}</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <EditTelemetryModuleForm
                            telemetryModule={id ? module! : defaultModule}
                            configuration={configuration}
                        />
                    )}
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
